import React from "react";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";
import ReturnSubCon from "./ReturnSubCon";
import Utility from './../../utilities/Utility';

export default class RouterReturnSubCon extends ReturnSubCon {
    /**
     * Submenu view for tabular router node output
     * @module RouterReturnSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            argumentName: null,
            varName: null,
            type: null,
            id:Utility.uuid4(),
            sensitiveData: false,
           
        };
    }

    isValidModel(){
        return this.varModel.argumentName && this.varModel.varName && (this.varModel.type || this.knownType);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const colSelection = window.apm.knowledgeBase.getIndexFromValue(this.varModel.argumentName, this.props.params.colOptions);
        const preSelection = window.apm.knowledgeBase.getVariableTypeIndexFromValue(this.varModel.type);

        return (
            <div>
                {<Dropdown 
                    context={this} 
                    label={this.getPropLabel("column_to_return")} 
                    optionName={this.getPropLabel("select_column")}
                    options={this.props.params.colOptions} 
                    valKey={"argumentName"}
                    selection={colSelection}
                    suppressUpdate={true}
                />}
                
                {<Input
                    label={this.getPropLabel("scoped_variable_name")}
                    hint={this.getPropLabel("scoped_variable_name_hint")} 
                    value={this.varModel.varName} 
                    valRules={{ "noEmpty": true, "varName": true }}
                    context={this} 
                    valKey={"varName"}
                    suggestion={"variable"}
                    suppressUpdate={true}
                />}

                {!this.knownType && 
                    <Dropdown 
                        wide={true} 
                        label={this.getPropLabel("variable_type")} 
                        optionName={this.getPropLabel("type_opt")}
                        options={window.apm.knowledgeBase.getVariableTypesForTabular()}
                        context={this} 
                        valKey={"type"}
                        selection={preSelection} 
                        suppressUpdate={true}
                    />
                }
                {(() => {
                    if (this.isKnownModel()) {
                        // Display edit and delete for editing
                        return (
                            <table style={{width: "100%"}}><tbody><tr>
                                <td style={{paddingRight: "2px"}}>
                                    {<Button icon={"icon-trash"} tint={"warning"}
                                             callback={() => {
                                                 this.remove();
                                             }}
                                    />}
                                </td>
                                <td>
                                    {<Button label={this.getPropLabel("save_output")} wide={true}
                                             callback={() => {
                                                 this.update();
                                             }}
                                    />}
                                </td>
                            </tr></tbody></table>
                        );
                    }
                    return (
                        <Button label={this.getPropLabel("add_output")} wide={true}
                                callback={() => {
                                    this.add();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}